import styled from "styled-components";
import {DataScope, Person, Profile, StyledBaseProps} from "@betrue/shared/interfaces";
import {Avatar, Badge, Card, CardContent, CardHeader, Grid, Link} from "@mui/material";
import {PROFILE_ROUTE} from "../help/routes";
import {SkillTag} from "../skill/skill-tag.styles";
import {personAvatarUrl} from "@betrue/front/services";
import {UserRatingView} from "../user-rating/user-rating.view";

export interface ProfileCardViewProps extends StyledBaseProps {
  profile: Profile
  person: Person
}

export const ProfileCardView = styled((props: ProfileCardViewProps) => (
  <span className={props.className}>
     <Link target={'_blank'} href={`${PROFILE_ROUTE}subjectId=${props.person.id}&&subject=${props.person.__typename}`}>
       <Card className={'bt-profile-card'}>
           <CardHeader
             className='card-header'
             avatar={

               <Avatar aria-label="recipe" className={'avatar'} src={personAvatarUrl((props.person))}>
                 {
                   props.person.firstName && props.person.lastName ?
                     props.person.firstName[0] + props.person.lastName[0] :
                     '??'
                 }
               </Avatar>
             }
             action={props.profile.price ? (<Grid>
               <Badge badgeContent={`${props.profile.price}€/J`} className={'bt-badge'}/>

             </Grid>) : ('')
             }
             title={`${props.person.firstName} ${props.person.lastName}`}

             subheader={<Grid container spacing={1}>
               <Grid
                 item>{props.profile.job?.label ? props.profile.job?.label : '...'}</Grid>{props.profile.dataScope === DataScope.FULL ? (
               <Grid item> <UserRatingView defaultValue={props.profile.rating} onRating={(c) => console.log(c)} readOnly={true}/>
               </Grid>) : ''}
             </Grid>}
           />

          <CardContent className={'card-skill-content'}>
            <Grid container direction={"row"} spacing={0}>

              {props.profile.skills.slice(0, 10).map((profileSkill) => (
                <Grid item key={profileSkill.id} className='skill-item'>
                  <SkillTag skill={profileSkill.skill} level={profileSkill.experienceLevel}/>
                </Grid>
              ))}
            </Grid>

          </CardContent>
        </Card>
        </Link>
  </span>
))`
  & .bt-profile-card {
  }

  a:hover {
    text-decoration: none;
  }

  & .avatar {
    text-transform: uppercase;
  }

  & .card-skill-content {
    font-size: 12px;
    overflow: hidden;
    height: 50px;
  }

  & .bt-badge {
    margin-right: 30px;
  }

  & .bt-badge span {
    background-color: ${props => props.theme.colors.accent};
    color: #FFF;
  }

  & .card-header {
    text-transform: capitalize;
  }
`
